import type { ButtonProps } from "@mui/material";
import { Button, Tooltip } from "@mui/material";
import { isString } from "lodash";
import type { MouseEvent, PropsWithChildren } from "react";
import { useState } from "react";

function AsyncLoadingButton({
  variant = "outlined",
  color = "primary",
  disabled,
  children,
  onClick,
  ...rest
}: PropsWithChildren<{
  readonly disabled?: boolean | string;
  readonly onClick: ((e: MouseEvent) => Promise<void>) | undefined;
}> &
  Omit<ButtonProps, "onClick" | "loading" | "disabled">) {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e: MouseEvent) => {
    setLoading(true);
    try {
      await onClick?.(e);
    } finally {
      setLoading(false);
    }
  };
  const buttonProps = {
    variant,
    color,
    loading,
    onClick: handleClick,
    ...rest,
  };
  return isString(disabled) ? (
    <Tooltip title={disabled}>
      <span>
        <Button disabled={true} {...buttonProps}>
          {children}
        </Button>
      </span>
    </Tooltip>
  ) : (
    <Button disabled={disabled} {...buttonProps}>
      {children}
    </Button>
  );
}

export default AsyncLoadingButton;
